import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  Typography,
  FormControl,
  TextField,
  CardContent,
  Grid,
  Button,
  MenuItem,
  Select,
  CircularProgress,
  Paper,
  Box,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { CloudUploadRounded } from "@mui/icons-material";
import Key from "../../../clientVariables.json";
import {
  addCandidateAction,
  alertSnackBarAction,
  getCandidateDetailAction,
  getActiveCandidatesAction,
  getCandidatesAction,
  getCandidateResumeListAction,
} from "../../redux/action";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import { userSelector } from "../../user-redux/selector";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const FileUploader = ({
  check,
  candidatesRefreshHandler,
  closeResumeParserModal,
  popupsHandler,
  primaryResumeData
}) => {
  const dispatch = useDispatch();
  const { candidateDetails, selectedCandidate, activeCandidates } = useSelector(appSelector);
  const { user } = useSelector(userSelector);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [parsedFileData, setParsedFileData] = useState([]);
  const [addCandidateData, setAddCandidateData] = useState([]);
  const [addResumesData, setAddResumesData] = useState([]);
  const [addCandidateAndAddResumeToS3, setAddCandidateAndAddResumeToS3] =
    useState([]);
  const [comonApiLoad, setComonApiLoad] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    // firstName: "",
    // lastName: "",
    name: "",
    email: "",
    jobTitle: "",
  });
  const [formErrors, setFormErrors] = useState({});

  const MAX_FILES = 5;

  const validateForm = () => {
    let errors = {};
    let isValid = true;

    // if (!formData.firstName.trim()) {
    //   errors.firstName = "First Name is required";
    //   isValid = false;
    // }

    if (!formData.name.trim()) {
      errors.name = "Name is required";
      isValid = false;
    }

    if (!formData.email.trim()) {
      errors.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Email is invalid";
      isValid = false;
    }

    if (!formData.jobTitle.trim()) {
      popupsHandler("Job Title is required", "error");
      //errors.jobTitle = "Job Title is required";
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };

  // useEffect(() => {
  //   console.log("primaryResumeData", primaryResumeData)
  // }, [primaryResumeData]);

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      if (check === "add_candidates") {
        const singleFile = files[0]; // Only take the first file
        validateAndAddFile(singleFile);
        getParseData(singleFile);
      } else if (check === "add_resumes") {
        // Allow multiple file uploads for add_resumes
        Array.from(files).forEach((file) => {
          validateAndAddFile(file);
          getParseData(file);
        });
      }
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (check === "add_candidates") {
      // Only take the first file if adding candidates
      if (files.length > 0) {
        const singleFile = files[0];
        validateAndAddFile(singleFile);
        getParseData(singleFile);
      }
    } else if (check === "add_resumes") {
      // Allow multiple file drops for adding resumes
      Array.from(files).forEach((file) => {
        validateAndAddFile(file);
        getParseData(file);
      });
    }
  };

  const validateAndAddFile = (file) => {
    const allowedFileTypes = [".docx", ".pdf", ".doc"];

    if (selectedFiles.length >= MAX_FILES) {
      popupsHandler(`You can upload a maximum of ${MAX_FILES} files.`, "error");
    } else if (
      !allowedFileTypes.includes(file.name.slice(file.name.lastIndexOf(".")))
    ) {
      popupsHandler(
        `You can add only .docx, .doc and .pdf files. The following file was not added: ${file.name}`,
        "error"
      );
    } else {
      setSelectedFiles([...selectedFiles, file]);
    }
  };

  const handleRemove = (index) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setSelectedFiles(updatedFiles);
    setFormOpen(false);
    setFormData({
      // firstName: "",
      // lastName: "",
      name: "",
      email: "",
      jobTitle: "",
    });
  };

  function validateEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(email)) {
      return false;
    }

    const invalidDomains = ["example.com", "test.com", "email.com"];

    const domain = email.split("@")[1];

    if (invalidDomains.includes(domain)) {
      return false;
    }

    return true;
  }

  const handleUpload = async () => {
    try {
      if (selectedFiles.length === 0) {
        popupsHandler("No files selected", "warning");
        return;
      }

      if (check === "add_candidates") {
        if (!validateForm()) {
          popupsHandler("Please fill out all required fields correctly", "error");
          return;
        }

        setIsUploading(true);

        // Check if email exists in activeCandidates
        const emailExists = Array.isArray(activeCandidates)
          ? activeCandidates.some(candidate => candidate.email === formData.email)
          : activeCandidates?.email === formData.email;

        if (emailExists) {
          popupsHandler("A candidate with this email already exists", "error");
          setIsUploading(false);
          return;
        }

        // Validate array lengths
        if (addCandidateData.length !== addCandidateAndAddResumeToS3.length) {
          console.error("Array length mismatch:", {
            addCandidateData: addCandidateData.length,
            addCandidateAndAddResumeToS3: addCandidateAndAddResumeToS3.length
          });
          popupsHandler("Data mismatch in candidate upload", "error");
          setIsUploading(false);
          return;
        }

        // Process add_candidates
        for (const element of addCandidateData) {
          if (!element?.candidateData || !element?.fileData) {
            console.error("Invalid candidate data or file:", element);
            popupsHandler("Invalid candidate data", "error");
            continue;
          }

          // element.candidateData.firstname = formData.firstName;
          // element.candidateData.lastname = formData.lastName;
          element.candidateData.name = formData.name;
          element.candidateData.email = formData.email;
          element.candidateData.jobtitle = formData.jobTitle;

          const parsedEmail = element?.candidateData?.email || null;
          const validEmail = await validateEmail(parsedEmail);

          if (!validEmail) {
            popupsHandler(`Invalid email: ${parsedEmail}`, "error");
            continue;
          }

          console.log("Adding candidate with data:", element.candidateData);
          const responseData = await dispatch(
            addCandidateAction(
              element?.candidateData,
              user?.id,
              element?.fileData
            )
          ).catch(err => {
            console.error("Error in addCandidateAction:", err);
            throw new Error(`Failed to add candidate: ${err.message}`);
          });

          if (responseData.data === "Candidate already exist") {
            await dispatch(getActiveCandidatesAction(user?.id, 1, 20));
            popupsHandler(responseData.data, "error");
            continue;
          }

          const resume = addCandidateAndAddResumeToS3.find(
            (item) => item.fileData === element.fileData
          );
          const resumeData = resume?.parsedData;
          const file = resume?.fileData;

          if (!resumeData || !file) {
            console.error("Missing resume data or file:", { resumeData, file });
            popupsHandler("Invalid resume data or file", "error");
            continue;
          }

          if (responseData?.data?.insertId) {
            await handleUpdateCandidateDetails(responseData?.data.insertId);
            const solrSearchArray = (resumeData?.solr_searchstring || "")
              .replace("job_role:(", "")
              .replace(/\\"/g, '"')
              .replace(")", "")
              .split(" OR ");
            const resumePayload = {
              candidate_id: responseData?.data.insertId,
              ai_skills: resumeData?.skills?.join(",") || "",
              user_id: user?.id,
              application_title: resumeData?.job_title || "",
              full_name: resumeData?.name || "",
              // first_name: resumeData?.first_name || "",
              // last_name: resumeData?.last_name || "",
              home_phone: resumeData?.phone || "",
              email_address: resumeData?.email || "",
              total_experience: resumeData?.experience_in_years || "",
              location_state: resumeData?.location_state || "",
              location_city: resumeData?.location_city || "",
              address_zipcode: "",
              skills_ids: "",
              summary: resumeData?.summary || "",
              current_role: resumeData?.job_title || "",
              status: "1",
              skills_titles: resumeData?.related_skills?.join(",") || "",
              location_country: "",
              jobtype: "",
              uploaded_uid: user?.id,
              visatype: resumeData?.visa || "",
              full_address: resumeData?.location !== ", " ? resumeData?.location : "",
              resume_string: resumeData?.resume_string || "",
              willingToRelocate: "",
              solr_search_string: solrSearchArray?.length > 0 ? solrSearchArray.join(",") : "",
              source: "fromBenchsales",
              primary: "",
              linkedin_url: resumeData?.linkedin_url || "",
              filename: resumeData?.filename || "",
              projects_data: resumeData?.projects?.length > 0 ? resumeData?.projects : [],
              educations_data: resumeData?.educations?.length > 0 ? resumeData?.educations : [],
              certificates_data: resumeData?.certifications?.length > 0 ? resumeData?.certifications : [],
            };

            console.log("Posting resumePayload:", resumePayload);
            const response = await axios.post(
              `${Key.domain}/candidate/bench_addFullResume`,
              resumePayload
            ).catch(err => {
              console.error("Error in bench_addFullResume:", err.response?.data || err.message);
              throw new Error(`Failed to add resume: ${err.response?.data?.error || err.message}`);
            });

            const resumeId = response?.data?.data?.insertId;
            if (!resumeId) {
              console.error("No resumeId returned:", response.data);
              popupsHandler("Failed to get resume ID", "error");
              continue;
            }

            const data = new FormData();
            data.append("file", file);
            data.append("userid", user?.id);
            data.append("candidateid", responseData?.data.insertId);
            data.append("filename", file.name);
            data.append("file_size", file.size.toString());
            data.append("file_type", file.type);
            data.append("attachment_type", "Candidate_res_attachment");
            data.append("attachment_name", file.name);
            data.append("file_created", file.lastModifiedDate ? new Date(file.lastModifiedDate).toISOString() : "");
            data.append("resumeid", resumeId.toString());
            data.append("role", resumeData?.job_title || "");

            console.log("FormData contents:", Array.from(data.entries()));
            await axios.post(
              `${Key.domain}/candidate/upload_document`,
              data
            ).catch(err => {
              console.error("Error in upload_document:", err.response?.data || err.message);
              throw new Error(`Failed to upload document: ${err.response?.data?.error || err.message}`);
            });

            await candidatesRefreshHandler(true);
            popupsHandler("Candidate added successfully", "success");
          }
        }
        setIsUploading(false);
        closeResumeParserModal(true);
      } else if (check === "add_resumes") {
        setIsUploading(true);

        // Validate array lengths
        if (addResumesData.length !== addCandidateAndAddResumeToS3.length) {
          console.error("Array length mismatch:", {
            addResumesData: addResumesData.length,
            addCandidateAndAddResumeToS3: addCandidateAndAddResumeToS3.length
          });
          popupsHandler("Data mismatch in resume upload", "error");
          setIsUploading(false);
          return;
        }

        // Log primaryResumeData for debugging
        //console.log("Primary Resume Data:", primaryResumeData);

        // Use uid for user_id and candidate_id directly
        const candidateId = primaryResumeData?.candidate_id;
        const userId = primaryResumeData?.uid || user?.id; // Fallback to user?.id

        // Validate candidateId and userId
        if (!candidateId || !userId) {
          console.error("Invalid primaryResumeData:", {
            primaryResumeData,
            candidateId,
            userId
          });
          popupsHandler(
            `Primary resume data is incomplete (missing candidate_id or user_id). Available data: ${JSON.stringify(primaryResumeData)}`,
            "error"
          );
          setIsUploading(false);
          return;
        }

        for (let i = 0; i < addResumesData.length; i++) {
          const resumeData = addResumesData[i];
          // Update resume data with edited form values (like ResumeUpload.jsx)
          resumeData.full_name = formData.name;
          resumeData.application_title = formData.jobTitle;
          resumeData.current_role = formData.jobTitle;
          resumeData.email_address = formData.email;

          const parsedEmail = resumeData.email_address;
          const primaryResumeEmail = primaryResumeData?.email_address;
          const primaryResumeName = primaryResumeData?.full_name || primaryResumeData?.name;

          // Skip email check if primaryResumeEmail is not available
          if (!parsedEmail || parsedEmail.trim() === "") {
            popupsHandler("Cannot add resume: Email not available in resume", "error");
            continue;
          }

          // if (
          //   formData.email?.toLowerCase().trim() !== primaryResumeEmail?.toLowerCase().trim() &&
          //   formData.name.toLowerCase().trim() !== primaryResumeName?.toLowerCase().trim()
          // ) {
          //   popupsHandler(
          //     `Email and Resume Name must match the primary resume's email (${primaryResumeEmail}) and name (${primaryResumeName})`,
          //     "error"
          //   );
          //   continue;
          // } else if (
          //   primaryResumeEmail &&
          //   formData.email?.toLowerCase().trim() !== primaryResumeEmail.toLowerCase().trim()
          // ) {
          //   popupsHandler(
          //     `Cannot add resume: Email ${formData.email} doesn't match primary resume email ${primaryResumeEmail}`,
          //     "error"
          //   );
          //   continue;
          // } else if (
          //   primaryResumeName &&
          //   formData.name.toLowerCase().trim() !== primaryResumeName.toLowerCase().trim()
          // ) {
          //   popupsHandler(
          //     `Cannot add resume: Name ${formData.name} doesn't match primary resume name ${primaryResumeName}`,
          //     "error"
          //   );
          //   continue;
          // }

          if (
            primaryResumeEmail &&
            formData.email?.toLowerCase().trim() !== primaryResumeEmail.toLowerCase().trim()
          ) {
            popupsHandler(
              `Resume email must match the primary resume's email (${primaryResumeEmail})`,
              "error"
            );
            continue;
          }

          const file = addCandidateAndAddResumeToS3[i].fileData;
          if (!file || !(file instanceof File)) {
            console.error("Invalid file at index:", i, file);
            popupsHandler("Invalid file data", "error");
            continue;
          }

          // Build resumePayload to match ResumeUpload.jsx structure
          const solrSearchArray = (resumeData?.solr_search_string || "")
            .replace("job_role:(", "")
            .replace(/\\"/g, '"')
            .replace(")", "")
            .split(" OR ");
          const resumePayload = {
            candidate_id: candidateId,
            ai_skills: resumeData?.ai_skills || "",
            user_id: userId,
            application_title: resumeData?.application_title || formData.jobTitle || "",
            full_name: resumeData?.full_name || formData.name || "",
            home_phone: resumeData?.home_phone || "",
            email_address: resumeData?.email_address || formData.email || "",
            total_experience: resumeData?.total_experience || "",
            location_state: resumeData?.location_state || "",
            location_city: resumeData?.location_city || "",
            address_zipcode: "",
            skills_ids: "",
            summary: resumeData?.summary || "",
            current_role: resumeData?.current_role || formData.jobTitle || "",
            status: "1",
            skills_titles: resumeData?.skills_titles || "",
            location_country: "",
            jobtype: "",
            uploaded_uid: user?.id,
            visatype: resumeData?.visatype || "",
            full_address: resumeData?.full_address !== ", " ? resumeData?.full_address : "",
            resume_string: resumeData?.resume_string || "",
            willingToRelocate: "",
            solr_search_string: solrSearchArray?.length > 0 ? solrSearchArray.join(",") : "",
            source: "fromBenchsales",
            primary: "",
            linkedin_url: resumeData?.linkedin_url || "",
            filename: resumeData?.filename || file.name || "",
            projects_data: resumeData?.projects_data?.length > 0 ? resumeData?.projects_data : [],
            educations_data: resumeData?.educations_data?.length > 0 ? resumeData?.educations_data : [],
            certificates_data: resumeData?.certificates_data?.length > 0 ? resumeData?.certificates_data : [],
          };

          const response = await axios.post(
            `${Key.domain}/candidate/bench_addFullResume`,
            resumePayload
          ).catch(err => {
            console.error("Error in bench_addFullResume:", err.response?.data || err.message);
            throw new Error(`Failed to add resume: ${err.response?.data?.error || err.message}`);
          });

          const resumeId = response?.data?.data?.insertId;
          if (!resumeId) {
            console.error("No resumeId returned:", response.data);
            popupsHandler("Failed to get resume ID", "error");
            continue;
          }

          const data = new FormData();
          data.append("file", file);
          data.append("userid", userId);
          data.append("candidateid", candidateId);
          data.append("filename", file.name);
          data.append("file_size", file.size.toString());
          data.append("file_type", file.type);
          data.append("attachment_type", "Candidate_res_attachment");
          data.append("attachment_name", file.name);
          data.append("file_created", file.lastModifiedDate ? new Date(file.lastModifiedDate).toISOString() : "");
          data.append("resumeid", resumeId.toString());
          data.append("role", resumePayload.application_title || "");

          console.log("FormData contents:", Array.from(data.entries()));
          await axios.post(
            `${Key.domain}/candidate/upload_document`,
            data
          ).catch(err => {
            console.error("Error in upload_document:", err.response?.data || err.message);
            console.log("Full error object:", err.response?.data?.error);
            throw new Error(`Failed to upload document: ${err.response?.data?.error || err.message}`);
          });

          popupsHandler("Resume added successfully", "success");
          const candidateData = {
            candidate_id: candidateId,
            user_id: user?.id,
          };
          await dispatch(getCandidateResumeListAction(candidateData)).catch(err => {
            console.error("Error in getCandidateResumeListAction:", err);
            throw new Error(`Failed to refresh resume list: ${err.message}`);
          });
        }
        setIsUploading(false);
        closeResumeParserModal(true);
      }
    } catch (error) {
      console.error("Error uploading files:", error.response?.data || error.message);
      console.log("Full error object:", error.response?.data?.error);
      popupsHandler(`Failed to upload files: ${error.response?.data?.error || error.message}`, "error");
      setIsUploading(false);
      closeResumeParserModal(true);
    }
  };

  const getParseData = async (fileData) => {
    setComonApiLoad(true);
    try {
      const formData = new FormData();
      formData.append("resume", fileData);

      const response = await fetch(Key.resume_parser_ai_4, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Failed to parse data: ${response.statusText}`);
      }

      const body = await response.json();
      const email = Array.isArray(body.data?.email)
        ? body.data.email[0]
        : body.data?.email || "";
      const phone = Array.isArray(body.data?.phone)
        ? body.data.phone[0]
        : body.data?.phone || "";

      if (
        body.statusCode === 200 &&
        body.data !== undefined &&
        body.data !== null
      ) {
        if (check === "add_candidates") {
          const candidateData = await {
            userid: user?.id,
            name: body.data?.name || "",
            //firstname: body.data?.first_name,
            middlename: "",
            //lastname: body.data?.last_name,
            email: email,
            phone: phone,
            date_of_birth: "",
            candidate_status: "Active",
            jobtitle: body.data?.job_title,
            visatype: body.data?.visa,
            related_titles: "",
            experience: body.data?.experience_in_years,
            address: "",
            zipcode: "",
            countryid: "",
            stateid: "",
            cityid: "",
            skills: body.data?.skills,
            summary: body.data?.summary,
            linkedInUrl: body.data?.linkedin_url,
            jobtypeid: "",
            availabledate: "",
            ratefrom: "",
            rateto: "",
            currentratetype: "",
            currentrate: "",
            gender: "",
            willingToRelocate: "No",
            role: body.data?.job_title,
          };
          console.log(
            "Full summary from parser:",
            body.data?.summary?.length,
            body.data?.summary,
            body.data?.email
          );
          setAddCandidateData((prev) => [
            ...prev,
            { fileData, parsedData: body.data, candidateData },
          ]);
          setAddCandidateAndAddResumeToS3((prev) => [
            ...prev,
            { parsedData: body.data, fileData },
          ]);
          setFormData({
            ...formData,
            // firstName: body.data.first_name || "",
            // lastName: body.data.last_name || "",
            name: body.data.name || "",
            email: body.data.email || "",
            jobTitle: body.data.job_title || "",
          });
          setFormOpen(true);
          popupsHandler("Resume parsed successfully", "success");
        } else if (check === "add_resumes") {
          const inputString = (await body.data?.solr_searchstring) || "";
          const solrSearchArray = await inputString
            .replace("job_role:(", "")
            .replace(/\\"/g, '"')
            .replace(")", "")
            .split(" OR ");
          const resumeData = await {
            candidate_id: selectedCandidate?.candidate_id,
            ai_skills: body.data?.skills?.join(",") || "",
            user_id: user?.id,
            application_title: body.data?.job_title || "",
            full_name: body.data?.name || "",
            // first_name: body.data?.first_name || "",
            // last_name: body.data?.last_name || "",
            name: body.data?.name || "",
            home_phone: phone,
            email_address: email,
            total_experience: body.data?.experience_in_years,
            location_state: body.data?.location_state || "",
            location_city: body.data?.location_city || "",
            address_zipcode: "",
            skills_ids: "",
            summary: body.data?.summary || "",
            current_role: body.data?.job_title,
            status: "1",
            skills_titles: body.data?.related_skills?.join(",") || "",
            location_country: "",
            jobtype: "",
            visatype: body.data?.visa || "",
            full_address: body.data?.location || "",
            resume_string: body.data?.resume_string || "",
            willingToRelocate: "",
            solr_search_string: solrSearchArray.join(","),
            source: "fromBenchsales",
            primary: "",
            linkedin_url: body.data?.linkedin_url || "",
            filename: body.data?.filename,
            projects_data: body.data?.projects || [],
            educations_data: body.data?.educations || [],
            certificates_data: body.data?.certifications || [],
          };
          setAddResumesData((prev) => [...prev, resumeData]);
          setAddCandidateAndAddResumeToS3((prev) => [
            ...prev,
            { parsedData: body.data, fileData },
          ]);
          setFormData({
            ...formData,
            // firstName: body.data.first_name || "",
            // lastName: body.data.last_name || "",
            name: body.data.name || "",
            email: email || "",
            jobTitle: body.data.job_title || "",
          });
          setFormOpen(true);
          popupsHandler("Resume parsed successfully", "success");
        }
      } else {
        throw new Error("Failed to parse data: invalid response format");
      }
    } catch (err) {
      console.error("Error parsing resume:", err);
      popupsHandler("Failed to parse resume, please try again", "error");
    } finally {
      setComonApiLoad(false);
    }
  };


  useEffect(() => {
    console.log(selectedCandidate)
    //console.log("Selected Candidate Email:", selectedCandidate?.email);
  }, [selectedCandidate]);

  const handleInputChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const handleUpdateCandidateDetails = async (candidateId) => {
    try {
      const response = await axios.post(
        `${Key.domain}/candidate/update/personal/${candidateId}`,
        {
          userid: user?.id,
          firstname: formData.firstName,
          lastname: formData.lastName,
          email: formData.email,
          jobtitle: formData.jobTitle,
        }
      );
      // dispatch(getCandidateDetailAction(candidateDetails?.candidate_id));
      popupsHandler("candidate personal details updated", "success");
    } catch (error) {
      console.error(error);
      popupsHandler("something went wrong", "error");
    }
  };

  return (
    <>
      <Paper
        sx={{
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
      >
        <Typography variant="h6" gutterBottom>
          Upload Resume Files To Add{" "}
          {check === "add_candidates" ? "Candidates" : "Resumes"}
          {/* `Resumes For ${candidateDetails?.candidate_name}` */}
        </Typography>
        <input
          accept=".docx, .pdf, .doc"
          id="file-upload"
          type="file"
          style={{ display: "none" }}
          onChange={handleFileChange}
          multiple
        />
        <label htmlFor="file-upload">
          <Button variant="outlined" component="span">
            {check === "add_candidates" ? "Select File" : "Select Files"}
          </Button>
        </label>
        <CloudUploadRounded
          sx={{ color: "#406882", height: "80px", width: "80px" }}
        />
        <Typography variant="subtitle1" style={{ marginTop: "2px" }}>
          or drag and drop files here
        </Typography>
        {formOpen ? (
          <Grid
            container
            spacing={2}
            sx={{
              ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
                padding: "8px 6px",
              },
              ".css-nxo287-MuiInputBase-input-MuiOutlinedInput-input": {
                padding: "8px 6px",
              },
              ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
                { padding: "8px 6px" },
            }}
          >
            {/* <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  First Name
                </Typography>
                <TextField
                  id="firstName"
                  label=""
                  variant="outlined"
                  placeholder="Jacob"
                  value={formData.firstName}
                  error={!!formErrors.firstName}
                  onChange={handleInputChange("firstName")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid> */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Full Name
                </Typography>
                <TextField
                  id="name"
                  label=""
                  variant="outlined"
                  placeholder="Full Name"
                  value={formData.name}
                  error={!!formErrors.name}
                  onChange={handleInputChange("name")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Email
                </Typography>
                <TextField
                  id="email"
                  label=""
                  variant="outlined"
                  placeholder="James@gmail.com"
                  value={formData.email}
                  error={!!formErrors.email}
                  onChange={handleInputChange("email")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Job Title
                </Typography>
                <TextField
                  id="jobTitle"
                  label=""
                  variant="outlined"
                  placeholder="Web Developer"
                  value={formData.jobTitle}
                  error={!!formErrors.jobTitle}
                  onChange={handleInputChange("jobTitle")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>
          </Grid>
        ) : null}
        {selectedFiles.map((file, index) => (
          <div key={index} style={{ marginTop: "10px", display: "flex" }}>
            <Typography
              sx={{
                minWidth: "150px",
                maxWidth: "150px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {file.name}
            </Typography>
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              style={{ marginLeft: "10px" }}
              onClick={() => handleRemove(index)}
            >
              {comonApiLoad ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Remove"
              )}
            </Button>
          </div>
        ))}
        <Button
          variant="contained"
          fullWidth
          color="primary"
          style={{
            marginTop: "20px",
            backgroundImage:
              "linear-gradient(360deg, #406882 0%, #518aa7 50%, #6d9ec6 100%)",
            textTransform: "capitalize",
          }}
          disabled={comonApiLoad}
          onClick={handleUpload}
        >
          {isUploading ? (
            <CircularProgress size={20} color="inherit" />
          ) : check === "add_candidates" ? (
            "Add Candidate"
          ) : (
            "Add Resumes"
          )}
        </Button>
      </Paper>
    </>
  );
};

export default FileUploader;

const labelStyles = {
  color: "rgb(160, 171, 184)",
  marginBottom: "5px",
};

const inputStyles = {
  border: "1px solid 	rgb(224, 230, 247)",
  borderRadius: "4px",
  "&:hover": {
    border: "1px solid 	rgb(224, 230, 247)",
    borderRadius: "4px",
  },
};
